import React, { useEffect } from "react";
import PageLoader from "./../components/PageLoader";
import { useAuth, requireAuth } from "./../util/auth.js";
import { useRouter } from "./../util/router.js";
import { redirectToCheckout } from "./../util/stripe.js";
import { useCookies } from 'react-cookie'
import {REFERRAL_USER_ID, REFERRAL_WIDGET_NAME} from 'pages/referralInvitation'

function PurchasePage(props) {
  const router = useRouter();
  const auth = useAuth();

  const [cookies, setCookie, removeCookie] = useCookies([REFERRAL_USER_ID, REFERRAL_WIDGET_NAME]);

  useEffect(() => {
    const referralUserId = cookies[REFERRAL_USER_ID]
    const referralWidgetName = cookies[REFERRAL_WIDGET_NAME]
    if (auth?.stripePartner?.planId && auth.stripePartner.planId !== "starter") {
      // If user already has a plan then take
      // them to Stripe billing to manage it
      router.push("/settings/billing");
    } else {
      // Otherwise go to checkout
      redirectToCheckout(router.query.plan, {
        referralUserId: referralUserId,
        referralWidgetName: referralWidgetName
      });
    }
  }, [auth.user.planId]);

  return <PageLoader></PageLoader>;
}

export default requireAuth(PurchasePage);
